import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"

import {
  getCateExerciseOne,
  getEntpExerciseConfigCurrent,
  exerciseDetailVerification,
  exerciseList,
  getEmployeeCourseOverStatus,
  getEmployeeExerciseCountByExerciseId,
  exerciseCollect,
  cateExerciseTwo
} from "@/apiCloud/examList"
import {getEmployeeInformation} from '@/apiCloud/userCenter'

let that;

//检测电脑设备是否已经安装了摄像头
if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
  // Firefox 38+ seems having support of enumerateDevicesx
  navigator.enumerateDevices = function (callback) {
    navigator.mediaDevices.enumerateDevices().then(callback);
  };
}
var MediaDevices = [];
var isHTTPs = location.protocol === 'https:';
var canEnumerate = false;

if (typeof MediaStreamTrack !== 'undefined' && 'getSources' in MediaStreamTrack) {
  canEnumerate = true;
} else if (navigator.mediaDevices && !!navigator.mediaDevices.enumerateDevices) {
  canEnumerate = true;
}

var hasMicrophone = false;
var hasSpeakers = false;
var hasWebcam = false;

var isMicrophoneAlreadyCaptured = false;
var isWebcamAlreadyCaptured = false;

export default {
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      paramObj: {
        exerciseType: "",
        catePatentId: "",
        cateId: ""
      },
      courseCatetoryPatentList: [],
      courseCatetorySubsetList: [],
      exerciseList: [],
      courseIds: '',
      isLogin: false,
      pageSize: 12,
      total: 0,
      pageNum: 1,
      examTypeList: [{
        name: "全部",
        value: "",
        isActive: true
      }, {
        name: "模拟考试",
        value: "0"
      }, {
        name: "练习题库",
        value: "1"
      }],
      isJx: false,
    }
  },
  created() {
    that = this;
    if (localStorage.getItem("enterpriseId")) {
      that.isLogin = true;
    }
    that.paramObj.exerciseType = that.$route.query.type;

    that.examTypeList.forEach(function (bObj) {
      that.$set(bObj, 'isActive', false);
      bObj.isActive = false;
      if (that.$route.query.type === bObj.value) {
        bObj.isActive = true;
      }
    });
    that.getCourseCatetoryPatentList();
    that.getExerciseList();
    if (localStorage.getItem("isJx") == "true") { // 是否是江西代理商访问
      this.isJx = true;
    }
    // var pUrl=window.location.href;
    //   // 是否是江西代理商访问
    //       if(pUrl=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http://jx.eceping.net"||pUrl.substring(0,pUrl.indexOf("/",7))=="http:/jx.eceping.net:8080"){//jx.eceping.net域名时,显示关于我们
    //       console.log(1111,this.isJx)
    //       this.isJx=true;
    //   }

  },
  methods: {
    //课程分类(大类)
    getCourseCatetoryPatentList() {
      let data = {}
      getCateExerciseOne(data).then(res => {
        if (res.code == 200) {
          this.courseCatetoryPatentList = res.rows;
          this.courseCatetoryPatentList.unshift({
            cateName: "全部",
            cateId: '',
            isActive: true
          })
          if (that.$route.query.catePatentId) {
            that.getCourseCatetorySubsetList(that.$route.query.catePatentId);
          } else {
            that.getExerciseList();
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //课程子级分类
    getCourseCatetorySubsetList(cateId, event) {
      that.paramObj.catePatentId = cateId;
      that.paramObj.cateId = "";
      /* that.paramObj.exerciseType="";*/
      this.courseCatetoryPatentList.forEach(function (cObj) {
        cObj.isActive = false;
        if (cateId == cObj.cateId) {
          cObj.isActive = true;
        }

      });
      /* if(cateId==""){
         this.courseCatetorySubsetList=[];
         return false;
       }*/
      let data = {
        catePatentId: cateId
      };
      if (cateId == undefined || cateId == "") {
        that.getExerciseList();
        this.courseCatetorySubsetList = []
        return false;
      }
      cateExerciseTwo(data).then(res => {
        if (res.code == 200) {
          this.courseCatetorySubsetList = res.data;
          if (this.courseCatetorySubsetList.length > 0) {
            this.courseCatetorySubsetList.unshift({
              cateName: "全部",
              cateId: "",
              isActive: true
            })
          }
          if (that.$route.query.cateId && event == undefined) {
            that.clickCourseCType(that.$route.query.cateId)
          } else {
            that.getExerciseList();
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    /*     //试卷列表
         getEnterpriseEmpCourse(){
           let url="home/getEnterpriseEmpCourse";
           getCourseList(url).then(res=>{
             if(res.success){
               that.courseIds=res.data;
               that.getExerciseList();
             }else{
               this.$message.error(res.message)
             }
           })
         },*/
    //试卷列表
    getExerciseList() {
      if ($('.examList') != undefined && $('.examList').offset() != undefined && $('.examList').offset().top != undefined) {
        var staff_top = $('.examList').offset().top - 160;
        $('html,body').animate({
          scrollTop: staff_top
        }, 500);
      }
      var data = {
        pageSize: that.pageSize,
        pageNum: that.pageNum,
        exerciseType: that.paramObj.exerciseType,
        catePatentId: that.paramObj.catePatentId,
        cateId: that.paramObj.cateId
      };
      that.exerciseList = [];
      exerciseList(data).then(res => {
        if (res.code == 200) {
          that.exerciseList = res.rows;
          that.total = res.total;
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //分页
    currentChange(page) {
      this.pageNum = page;
      this.getExerciseList()
    },
    /* goToExamDetail(examId, courseId) {
      let url = "exercise/exerciseDetailVerification";
      let data = {
        exerciseId: examId,
        courseId: courseId
      };
      getExam(url, data).then(res => {
        if (res.success) {
          this.$router.push({
            path: "/examDetail",
            query: {
              exerciseId: examId,
              courseId: courseId
            }
          });
        } else {
          this.$alert(res.message, '提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      })
    }, */
    // 练习验证是否购买
    getSell(examId, courseId, exerciseCate) {
      let data = {
        exerciseId: examId,
        courseId: courseId
      };
      exerciseDetailVerification(data).then(res => {
        if (res.code == 200) {
          if (exerciseCate == 0) {
            this.goToExamDetail(examId, courseId, exerciseCate)
          } else if (exerciseCate == 1) {
            that.$router.push({
              path: "/examDetail",
              query: {
                exerciseId: examId,
                courseId: courseId,
                exerciseCate: exerciseCate
              }
            });
          }
        } else {
          that.$alert(res.message, '提示', {
            confirmButtonText: '确定',
            callback: action => {}
          });
        }
      })
    },
    goToExamDetail(examId, courseId, exerciseCate) {
      console.log(courseId)
      if (courseId) {
        let url1 = "employee/getEmployeeInformation"
        getEmployeeInformation({}).then(response => {
          if (response.code == 200) {
            let data = {
              exerciseId: examId
            };
            getEntpExerciseConfigCurrent(data).then(res => {
              if (res.data.needRealName == 0) {
                if (!response.data.empIdcardFront) {
                  this.$message({
                    message: '请先进行实名认证',
                    type: 'warning',
                    duration: '3000',
                  })
                } else {
                  //判断练习时间限制
                  if (res.data.exerciseTimeLimit == 1) {
                    let data2 = {
                      courseId: courseId,
                      empId: response.data.empId
                    }
                    getEmployeeCourseOverStatus(data2).then(ressss => {
                      if (ressss.data != 1) {
                        this.$message({
                          message: "请先学完课程在进行练习",
                          type: "warning",
                          duration: "3000",
                        });
                      } else {
                        //判断练习次数限制
                        if (res.data.exerciseNumberLimit == 1) {
                          let data = {}
                          data.exerciseId = examId
                          data.empId = response.data.empId
                          getEmployeeExerciseCountByExerciseId(data).then(reseee => {
                            if (reseee.data >= res.data.maxExerciseNumber) {
                              this.$message({
                                message: "当前练习次数已用完",
                                type: "warning",
                                duration: "3000",
                              });
                            } else {
                              that.$router.push({
                                path: "/examDetail",
                                query: {
                                  exerciseId: examId,
                                  courseId: courseId,
                                  exerciseCate: exerciseCate,
                                  resultShow: res.data.resultShow
                                }
                              });
                            }
                          })
                        } else {
                          that.$router.push({
                            path: "/examDetail",
                            query: {
                              exerciseId: examId,
                              courseId: courseId,
                              exerciseCate: exerciseCate,
                              resultShow: res.data.resultShow
                            }
                          });
                        }
                      }
                    })
                  } else {
                    //判断练习次数限制
                    if (res.data.exerciseNumberLimit == 1) {
                      let data = {}
                      data.exerciseId = examId
                      data.empId = response.data.empId
                      getEmployeeExerciseCountByExerciseId(data).then(reseee => {
                        if (reseee.data >= res.data.maxExerciseNumber) {
                          this.$message({
                            message: "当前练习次数已用完",
                            type: "warning",
                            duration: "3000",
                          });
                        } else {
                          that.$router.push({
                            path: "/examDetail",
                            query: {
                              exerciseId: examId,
                              courseId: courseId,
                              exerciseCate: exerciseCate,
                              resultShow: res.data.resultShow
                            }
                          });
                        }
                      })
                    } else {
                      that.$router.push({
                        path: "/examDetail",
                        query: {
                          exerciseId: examId,
                          courseId: courseId,
                          exerciseCate: exerciseCate,
                          resultShow: res.data.resultShow
                        }
                      });
                    }
                  }
                }
              } else {
                //判断练习时间限制
                if (res.data.exerciseTimeLimit == 1) {
                  let data2 = {
                    courseId: courseId,
                    empId: response.data.empId
                  }
                  getEmployeeCourseOverStatus(data2).then(ressss => {
                    if (ressss.data != 1) {
                      this.$message({
                        message: "请先学完课程在进行练习",
                        type: "warning",
                        duration: "3000",
                      });
                    } else {
                      //判断练习次数限制
                      if (res.data.exerciseNumberLimit == 1) {
                        let data = {}
                        data.exerciseId = examId
                        data.empId = response.data.empId
                        getEmployeeExerciseCountByExerciseId(data).then(reseee => {
                          if (reseee.data >= res.data.maxExerciseNumber) {
                            this.$message({
                              message: "当前练习次数已用完",
                              type: "warning",
                              duration: "3000",
                            });
                          } else {
                            that.$router.push({
                              path: "/examDetail",
                              query: {
                                exerciseId: examId,
                                courseId: courseId,
                                exerciseCate: exerciseCate,
                                resultShow: res.data.resultShow
                              }
                            });
                          }
                        })
                      } else {
                        that.$router.push({
                          path: "/examDetail",
                          query: {
                            exerciseId: examId,
                            courseId: courseId,
                            exerciseCate: exerciseCate,
                            resultShow: res.data.resultShow
                          }
                        });
                      }
                    }
                  })
                } else {
                  //判断练习次数限制
                  if (res.data.exerciseNumberLimit == 1) {
                    let data = {}
                    data.exerciseId = examId
                    data.empId = response.data.empId
                    getEmployeeExerciseCountByExerciseId(data).then(reseee => {
                      if (reseee.data >= res.data.maxExerciseNumber) {
                        this.$message({
                          message: "当前练习次数已用完",
                          type: "warning",
                          duration: "3000",
                        });
                      } else {
                        that.$router.push({
                          path: "/examDetail",
                          query: {
                            exerciseId: examId,
                            courseId: courseId,
                            exerciseCate: exerciseCate,
                            resultShow: res.data.resultShow
                          }
                        });
                      }
                    })
                  } else {
                    that.$router.push({
                      path: "/examDetail",
                      query: {
                        exerciseId: examId,
                        courseId: courseId,
                        exerciseCate: exerciseCate,
                        resultShow: res.data.resultShow
                      }
                    });
                  }
                }
              }
            })
          }
        })
      } else {

      }

      // that.$confirm('测试开始后，会进行实时人脸拍照，请尽量端正坐姿，使面部完全置于拍摄区域内，谢谢您的配合！！！', '考试温馨提示', {
      //   confirmButtonText: '我知道了，开始测试',
      //   showCancelButton: false,
      //   closeOnClickModal: false,
      //   type: 'warning'
      // }).then(() => {
      //   that.checkDeviceSupport(function () {
      //     console.log(hasWebcam, "hasWebcam");
      //     if (hasWebcam == false) {
      //       that.$message.warning({
      //         message: '捕获摄像头失败，请安装摄像头！',
      //         duration: 1000
      //       })
      //       return false;
      //     } else {
      //       that.getSell(examId, courseId);
      //     }
      //   });
      // }).catch(() => {});

    },
    clickExamType(value) {
      that.paramObj.exerciseType = value;
      that.examTypeList.forEach(function (bObj) {
        that.$set(bObj, 'isActive', false);
        bObj.isActive = false;
        if (value === bObj.value) {
          bObj.isActive = true;
        }
      });
      that.getExerciseList();
    },
    clickCourseCType(value) {
      that.paramObj.cateId = value;
      that.courseCatetorySubsetList.forEach(function (obj) {
        that.$set(obj, 'isActive', false);
        obj.isActive = false;
        if (value == obj.cateId) {
          obj.isActive = true;
        }
      });
      that.getExerciseList();
    },
    goCollect(obj) { //添加 取消收藏
      console.log(obj)
      var title = obj.collectType == 1 ? "取消收藏" : "收藏";
      var data = {
        collectType: obj.collectType == 1 ? 0 : 1,
        exerciseId: obj.id,
        courseId: obj.courseId
      };
      exerciseCollect(data).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'warning ',
            message: '已' + title,
            duration: 1000

          });
          obj.collectType = obj.collectType == 1 ? 0 : 1;
          /*  that.getExerciseList();*/
        } else {
          this.$message.error(res.message)
        }
      })
      /*  this.$confirm('确定要'+title+'吗', '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
          let url="exercise/exerciseCollect";
          var data={
            collectType:obj.collectType==1?0:1,
            exerciseId:obj.id
          };
          getExamByPost(url,data).then(res=>{
            if(res.success){
              that.getExerciseList();
            }else{
              this.$message.error(res.message)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });*/
    },
    //返回上一页
    goBack() {
      // this.$router.go(-1)
    },
    checkDeviceSupport(callback) { // 检测是否安装摄像头
      if (!canEnumerate) {
        return;
      }

      if (!navigator.enumerateDevices && window.MediaStreamTrack && window.MediaStreamTrack.getSources) {
        navigator.enumerateDevices = window.MediaStreamTrack.getSources.bind(window.MediaStreamTrack);
      }

      if (!navigator.enumerateDevices && navigator.enumerateDevices) {
        navigator.enumerateDevices = navigator.enumerateDevices.bind(navigator);
      }

      if (!navigator.enumerateDevices) {
        if (callback) {
          callback();
        }
        return;
      }

      MediaDevices = [];
      navigator.enumerateDevices(function (devices) {
        devices.forEach(function (_device) {
          var device = {};
          for (var d in _device) {
            device[d] = _device[d];
          }

          if (device.kind === 'audio') {
            device.kind = 'audioinput';
          }

          if (device.kind === 'video') {
            device.kind = 'videoinput';
          }

          var skip;
          MediaDevices.forEach(function (d) {
            if (d.id === device.id && d.kind === device.kind) {
              skip = true;
            }
          });

          if (skip) {
            return;
          }

          if (!device.deviceId) {
            device.deviceId = device.id;
          }

          if (!device.id) {
            device.id = device.deviceId;
          }

          if (!device.label) {
            device.label = 'Please invoke getUserMedia once.';
            if (!isHTTPs) {
              device.label = 'HTTPs is required to get label of this ' + device.kind + ' device.';
            }
          } else {
            if (device.kind === 'videoinput' && !isWebcamAlreadyCaptured) {
              isWebcamAlreadyCaptured = true;
            }

            if (device.kind === 'audioinput' && !isMicrophoneAlreadyCaptured) {
              isMicrophoneAlreadyCaptured = true;
            }
          }

          if (device.kind === 'audioinput') {
            hasMicrophone = true;
          }

          if (device.kind === 'audiooutput') {
            hasSpeakers = true;
          }

          if (device.kind === 'videoinput') {
            hasWebcam = true;
          }

          // there is no 'videoouput' in the spec.

          MediaDevices.push(device);
        });

        if (callback) {
          callback();
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/examList/examList.js